import React from "react";

import { AppBar, Toolbar, Typography, Avatar } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
    toolbar: {
        padding: 0,
    },
    logoSection: {
        height: 45,
        width: 100,
        background: `url("/assets/clc_logo.png") no-repeat center`,
        backgroundSize: "100% auto",
        "@media (min-width:400px)": {
            height: 45,
            width: 160,
        },
    },
    logoWrapper: {
        backgroundColor: "#ffffff",
        height: 64,
        width: 160,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "@media (min-width:400px)": {
            height: 64,
            width: 220,
        },
    },
    user: {
        flexGrow: 1,
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        padding: "0px 10px",
    },
    name: {
        color: "#ffff",
        textAlign: "right",
        margin: "0 10px",
        fontSize: 12,
        "@media (min-width:400px)": {
            fontSize: 16,
        },
    },
    avatar: {
        height: 20,
        width: 20,
        fontSize: 12,
        backgroundColor: "#ffffff",
        color: "#19c686",
        fontWeight: "bold",
        "@media (min-width:400px)": {
            height: 30,
            width: 30,
            fontSize: 14,
        },
    },
});

export interface AppbarProps {
    firstName: string;
    lastName: string;
}

const Appbar: React.FC<AppbarProps> = ({ firstName, lastName }) => {
    const css = useStyles();
    return (
        <AppBar position="static" elevation={1}>
            <Toolbar className={css.toolbar} disableGutters>
                <div className={css.logoWrapper}>
                    <div className={css.logoSection} />
                </div>
                <div className={css.user}>
                    {firstName && lastName && (
                        <Avatar className={css.avatar}>{`${firstName
                            .charAt(0)
                            .toUpperCase()}${lastName
                            .charAt(0)
                            .toUpperCase()}`}</Avatar>
                    )}
                    <Typography variant="subtitle1" className={css.name}>
                        {`${firstName} ${lastName}`}
                    </Typography>
                </div>
            </Toolbar>
        </AppBar>
    );
};

export default Appbar;
